/**
 * Created by dorin on 6/22/17.
 */
import React from 'react';
import { connect } from 'react-redux';
import NavButtons from '../NavButtons';
import { Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class ResendVerificationLink extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      email: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status, error, dispatch } = nextProps;

    if (status === actionTypes.RESEND_CONFIRMATION_LINK_ERROR) {
      this.setState({ loading: false });
      if (error) {
        dispatch(actions.alert('error', error));
      } else {
        dispatch(
          actions.alert(
            'error',
            'Oops! Something went wrong. Please try to resend again. If this error persists, please contact us.'
          )
        );
      }
    } else if (status === actionTypes.RESEND_CONFIRMATION_LINK_SUCCESS) {
      this.setState({ loading: false });
      dispatch(
        actions.alert(
          'success',
          'Email confirmation resent. Please check your inbox and follow the directions to verify your email address.'
        )
      );
      this.props.router.push('/login');
    }
  }

  handleChange = (e) => {
    this.setState({ email: e.target.value });
  };

  send(e) {
    e.preventDefault();

    const { dispatch } = this.props;
    const { email } = this.state;

    dispatch(actions.hideAlert());

    if (email !== '') {
      this.setState({ loading: true });
      dispatch(actions.resendConfirmationLink(email.toLowerCase()));
    }
  }

  render() {
    const { loading, email } = this.state;

    return (
      <div className="forgot-password">
        <h3 className="title">Resend email verification link</h3>
        <p>
          If an account is associated with your email address, a email
          verification link will be sent to your email.
        </p>
        <hr className="transparent" />

        <Form onSubmit={(e) => this.send(e)}>
          <FormGroup>
            <FormControl
              type="email"
              placeholder="Email"
              autoFocus
              required
              value={email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup className="actions mt-30px">
            <div>
              <NavButtons
                direction="back"
                prev={() => this.props.router.push('/login')}
              />
            </div>
            <div>
              <button type="submit" disabled={loading}>
                {loading && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                resend verification link
              </button>
            </div>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.auth.status,
  error: state.auth.error,
});

export default connect(mapStateToProps)(ResendVerificationLink);



// WEBPACK FOOTER //
// src/components/Auth/ResendVerificationLink.jsx